module.exports = __webpack_public_path__ + "static/media/s2-bottom-right.16b4da8c.png";